import { createContext, useContext } from "react";
import { Canny } from "../makes/Canny";
const CannyContext = createContext({
    isLoaded: false,
    canny: new Canny(null)
});
const useCannyContext = () => {
    return useContext(CannyContext);
};
export { useCannyContext, CannyContext };
